import { render } from "./TabClose.vue?vue&type=template&id=72beb1f0&scoped=true"
import script from "./TabClose.vue?vue&type=script&lang=js"
export * from "./TabClose.vue?vue&type=script&lang=js"

import "./TabClose.vue?vue&type=style&index=0&id=72beb1f0&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72beb1f0"]])

export default __exports__